import { TrackedButton, Typography } from '@automata/ui';
import { Stack } from '@mui/material';

export type Props = {
  onClickReturnToWorkflow: () => void;
};

const PreviewCancelledDisplay = ({
  onClickReturnToWorkflow,
}: Props): JSX.Element => {
  return (
    <Stack p={3}>
      <Stack justifyContent="center" alignItems="center" paddingY={4} gap={2}>
        <Typography variant="h4" component="h2">
          Preview cancelled
        </Typography>
        <Typography variant="subtitle1" component="h3">
          The workflow preview was cancelled before a feasible solution could be
          found. You can return to the workflow builder to make changes and try
          again.
        </Typography>
        <TrackedButton
          trackLabel="workflowPlanning.returnToWorkflow"
          onClick={onClickReturnToWorkflow}
          variant="contained"
          color="primary"
        >
          Return to Workflow
        </TrackedButton>
      </Stack>
    </Stack>
  );
};

export default PreviewCancelledDisplay;
